import styled from '@emotion/styled';

const Trigger = styled.button(({ theme }) => ({
  border: 0,
  background: 'none',
  padding: 0,
  font: 'inherit',
  color: 'inherit',
  cursor: 'pointer',
  borderRadius: theme.eclipseTier1.radius['8px'],
  outline: '2px solid transparent',
  outlineOffset: 2,
  // TODO: Extract focus-visible styling into separate styles file and reference it here
  ':focus-visible': {
    outlineColor: theme.eclipseTier2Color.border.focus,
    position: 'relative',
  },
}));

export const S = {
  Trigger,
} as const;
